import { useQuery } from '@apollo/client/react';

import { GetCompanyPasswordPolicyDocument } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';
import { DEFAULT_PASSWORD_POLICY, PasswordPolicy } from '~/utils/password';

// 本部・店舗の画面向け。ログイン導線は認証セッションが無いため REST から取る
export const useFetchPasswordPolicy = (): { policy: PasswordPolicy; loading: boolean } => {
  const { data, loading } = useQuery(GetCompanyPasswordPolicyDocument);
  const company = data ? getMe(data)?.organization.company : undefined;

  return {
    policy: company
      ? {
          minimumLength: company.passwordMinimumLength,
          alphanumericRequired: company.passwordAlphanumericRequired,
        }
      : DEFAULT_PASSWORD_POLICY,
    loading,
  };
};
